/**
 * 判断值是否是undefined或null
 */
export const isNoneValue = (val: unknown) => {
  if (val === undefined || val === null) {
    return true;
  }
  return false;
};

/**
 * 如果不是undefined或null则返回指定的第二个参数
 */
export const noneValueOr = <T>(val: unknown, or: T): T => {
  if (isNoneValue(val)) {
    return val as T;
  }
  return or;
};

/**
 *  如果是undefined或null则返回指定的第二个参数
 */
export const noneValueThen = <T>(val: unknown, then: T): T => {
  if (!isNoneValue(val)) {
    return val as T;
  }
  return then;
};
